// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footerCopyright":"footer_footerCopyright__rLA8A","footerFollowUs":"footer_footerFollowUs__K0MYx"};